import type React from "react";
import type { SpecialFieldGroup, SpecialFieldItem } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { BirthYearField } from "./BirthYear/BirthYearField";
import { Place } from "./Place/Place";
import { SpecialFieldLabel } from "./types";
import styles from "./SpecialEventsGroup.module.scss";

interface SpecialEventsProps {
    fieldGroup: SpecialFieldGroup;
}

const SpecialFieldMapper = ({ field }: { field: SpecialFieldItem }) => {
    if (field.label === SpecialFieldLabel.Birth) return <BirthYearField birthYearField={field} />;
    if (field.label === SpecialFieldLabel.Place) return <Place field={field} />;
    return null;
};

export const SpecialEvents: React.FC<SpecialEventsProps> = ({ fieldGroup }) => (
    <div className={styles.fieldGroupSpacing}>
        <Grid.Container>
            {fieldGroup.specialFields?.map((field) => <SpecialFieldMapper key={field.label} field={field} />)}
        </Grid.Container>
    </div>
);
